import MobileControllersHeader from './MobileObjectsControlHeader'

export default MobileControllersHeader